import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Product } from '@mwe/models';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { WizardProductCardContainerComponent } from './wizard-product-card-container.component';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-wizard-product-card-list',
  templateUrl: './wizard-product-card-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SafeHtmlPipe, TranslatePipe, TranslateDirective, WizardProductCardContainerComponent],
})
export class WizardProductCardListComponent {
  listTitleKey = input<string>();
  listHeaderKey = input<string>();
  productList = input.required<Product[]>();
  isAvailableAtNewAddress = input<boolean>(false);
  isRelocationProcess = input(false);
}
